import getMenuBarItems from "./menubar";

export const isUrlCliente = (url: string): boolean => ((/\/componentesQR\/.+/).test(url) || url === '/');

const urlChecker = (mainUrl: string, incomingUrl: string): boolean => ((new RegExp("\\" + mainUrl + "(\\/.+)*")).test(incomingUrl) || (/\/users\/currentUser\/.+/).test(incomingUrl));

export const checkUrlByRoles = (roles: string[], url: string): boolean => {
    const menuBarItems = getMenuBarItems(roles);
    if (menuBarItems.length === 0) {
        if (roles.includes("CLIENTE")) {
            return isUrlCliente(url);
        } else {
            return false;
        }
    } else {
        const finalUrl = url === '/' ? '/ordenesProceso' : url;
        return menuBarItems.some((item) => urlChecker(item.href, finalUrl));
    }
}

export const fixUrlSpecialCharacters = (item: string): string => encodeURIComponent(item);